<template>
  <a-menu mode="inline" :selectedKeys="[selectedKey]">
    <template v-if="auth.role === 'CUSTOMER'">
      <a-menu-item key="/customer/day" @click="$emit('go','/customer/day')">
        Заказ на день
      </a-menu-item>

      <a-menu-item key="/customer/week-report" @click="$emit('go','/customer/week-report')">
        Отчет за неделю
      </a-menu-item>

      <a-menu-item key="/customer/week-print" @click="$emit('go','/customer/week-print')">
        Печать недели
      </a-menu-item>

      <a-menu-item key="/customer/children" @click="$emit('go','/customer/children')">
        Дети
      </a-menu-item>

      <a-menu-item key="/customer/profile" @click="$emit('go','/customer/profile')">
        Профиль
      </a-menu-item>
    </template>

    <template v-else-if="auth.role === 'KITCHEN'">
      <a-menu-item key="/kitchen/day" @click="$emit('go','/kitchen/day')">
        День кухни
      </a-menu-item>

      <a-menu-item key="/kitchen/order-edit" @click="$emit('go','/kitchen/order-edit')">
        Изменить заказ
      </a-menu-item>

      <a-menu-item key="/kitchen/audit" @click="$emit('go','/kitchen/audit')">
        Аудит
      </a-menu-item>

      <a-menu-item key="/kitchen/print-day" @click="$emit('go','/kitchen/print-day')">
        Печать на день
      </a-menu-item>

      <a-menu-item key="/kitchen/children" @click="$emit('go','/kitchen/children')">
        Дети
      </a-menu-item>

      <a-menu-item key="/kitchen/contractors" @click="$emit('go','/kitchen/contractors')">
        Заказчики
      </a-menu-item>

      <a-menu-item key="/kitchen/special-types" @click="$emit('go','/kitchen/special-types')">
        Особые виды питания
      </a-menu-item>

      <a-menu-item key="/kitchen/tags" @click="$emit('go','/kitchen/tags')">
        Теги
      </a-menu-item>

      <a-menu-item key="/kitchen/users" @click="$emit('go','/kitchen/users')">
        Пользователи
      </a-menu-item>
    </template>
  </a-menu>
</template>

<script setup>
import { useAuthStore } from '../stores/auth'

defineProps(['selectedKey'])
defineEmits(['go'])

const auth = useAuthStore()
</script>
